import { AkaHealthProductDetailsFormValues } from "./akaHealthProductDetailsInterfaces";

export const AKA_HEALTH_PRODUCT_DETAILS_INITIAL_FORM_VALUES: Partial<AkaHealthProductDetailsFormValues> =
  {
    isFitForWork: undefined,
    isOnSickLeave: undefined,
    inTreatment: undefined,
    isPlannedAnyKindOfTreatment: undefined,
  };
